<template>
  <div>
    <div
      id="quickviewDefault"
      class="quickview is-header-align"
      :class="{'is-active': active, 'has-background-light': mode === 'CONTACT_SEARCHES'}">
      <header class="quickview-header is-border-bottom">
        <div
          class="is-flex"
          style="align-items: center;">
          <a
            v-if="params && params.previousMode"
            @click="goBack">
            <span class="icon is-medium is-margin-left-small has-cursor-pointer has-text-grey">
              <i
                class="fal fa-arrow-left"
                style="font-size: 1.25rem;">
              </i>
            </span>
          </a>
          <h1
            class="title is-size-5 is-margin-left">
            {{ title }}
          </h1>
        </div>
        <div v-if="hasButton">
          <button
            class="button is-dark is-radius-large is-size-7"
            @click="buttonAction">
            <span class="icon is-small is-margin-right-small"><i
              class="fas"
              :class="buttonIcon"></i></span>
            <span>{{ buttonTitle }}</span>
          </button>
        </div>
        <a
          v-else
          @click="close()">
          <span class="icon is-medium is-margin-right-small has-cursor-pointer has-text-grey">
            <i class="fal fa-times"></i>
          </span>
        </a>
      </header>
      <div
        id="gotop"
        class="quickview-body">
        <component
          v-if="mode"
          ref="innerComponent"
          class="quickview-block"
          :is="currentComponent"
          :params-quickview="params"
          :event="params.event"
          :source="params.source"
          :facets="params.facets"
          :includes="params.includes"
          :excludes="params.excludes"
          :quickview-filters="params.filters"
          :mode="params.mode"
          :from-quickview="true"
          @submitQuickview="submitQuickview"
          @iCanSubmit="iCanSubmit = $event"></component>
      </div>
      <footer
        v-if="!noFooter"
        class="quickview-footer is-borderless has-background-light">
        <button
          v-if="params && params.alert"
          @click="askSubmit()"
          class="button is-danger is-fullwidth"
          :disabled="!iCanSubmit || quickviewLoading">
          <span v-if="!quickviewLoading">CONFIRMEZ L'ENREGISTREMENT</span>
          <span v-else><i class="fal fa-spin fa-spinner"></i></span>
        </button>
        <button
          v-else
          @click="askSubmit()"
          class="button is-success is-fullwidth"
          :disabled="!iCanSubmit || quickviewLoading">
          <span v-if="!quickviewLoading">{{ validerLabel }}</span>
          <span v-else><i class="fal fa-spin fa-spinner"></i></span>
        </button>
      </footer>
    </div>
    <div
      class="quickview-overlay"
      @click="$store.commit('setQuickview', { mode: null, params: null, results: null, close: true })"></div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

const MODES = Object.freeze({
  MANAGE_NOTIFICATION: 'MANAGE_NOTIFICATION',
  USER_SELECTION: 'USER_SELECTION',
  RELATION_SELECTION: 'RELATION_SELECTION',
  CONTACT_SELECTION: 'CONTACT_SELECTION',
  CONTACT_CREATE: 'CONTACT_CREATE',
  USER_CREATE: 'USER_CREATE',
  CONTACT_UPDATE: 'CONTACT_UPDATE',
  CONTACT_SEARCHES: 'CONTACT_SEARCHES',
  NOTE_CREATE: 'NOTE_CREATE',
  NOTES_LIST: 'NOTES_LIST',
  LOT_SELECTION: 'LOT_SELECTION',
  LOT_SELECTION_AMENAGEMENT: 'LOT_SELECTION_AMENAGEMENT',
  OPTION_UPDATE_DATE: 'OPTION_UPDATE_DATE',
  NEW_CALENDAR_ACTION: 'NEW_CALENDAR_ACTION',
  PROMOTEUR_UPDATE: 'PROMOTEUR_UPDATE',
  INTERLOCUTEUR_FORM: 'INTERLOCUTEUR_FORM'
})

export default {
  name: 'Quickview',
  components: {
    EntitySelection: () => import('./EntitySelection'),
    UserInvitation: () => import('./UserInvitation'),
    ContactSearch: () => import('./ContactSearch'),
    ContactForm: () => import('@/components/contacts/ContactForm'),
    UserQuickviewForm: () => import('./UserQuickviewForm'),
    LotSelection: () => import('./LotSelection'),
    ManageNotification: () => import('./ManageNotification'),
    OptionUpdateDateModal: () => import('@/components/options/OptionUpdateDateModal'),
    NoteCreate: () => import('./NoteCreate'),
    NewCalendarAction: () => import('./NewCalendarAction'),
    NotesList: () => import('./NotesList'),
    PromoteurForm: () => import('./PromoteurForm'),
    InterlocuteurForm: () => import('./InterlocuteurForm')
  },
  data () {
    return {
      iCanSubmit: true,
      modes: MODES,
      active: false,
      results: {},
      mode: null,
      params: null,
      validerLabel: 'Valider',
      forContactVue: [
        'DenunciationCreate',
        'OptionCreate',
        'AdvInfos',
        'PreReservation'
      ]
    }
  },
  computed: {
    ...mapState(['quickview', 'quickviewActive', 'quickviewLoading']),
    noFooter () {
      let buttons = {
        [MODES.NOTES_LIST]: true
      }
      return buttons[this.mode]
    },
    hasButton () {
      let buttons = {
        [MODES.NOTES_LIST]: true
      }
      return buttons[this.mode]
    },
    buttonTitle () {
      let titles = {
        [MODES.NOTES_LIST]: 'Ajouter note'
      }
      return titles[this.mode]
    },
    buttonIcon () {
      let titles = {
        [MODES.NOTES_LIST]: 'fa-pen-alt'
      }
      return titles[this.mode]
    },
    buttonAction () {
      let actions = {
        [MODES.NOTES_LIST]: this.newNote
      }
      if (this.mode in actions) {
        return actions[this.mode]
      } else return () => {}
    },
    title () {
      let titles = {
        [MODES.LOT_SELECTION]: 'Lots du programme',
        [MODES.LOT_SELECTION_AMENAGEMENT]: 'Lots du lotissement',
        [MODES.MANAGE_NOTIFICATION]: 'Gestion des notifications',
        [MODES.USER_SELECTION]: 'Sélection d\'un utilisateur',
        [MODES.RELATION_SELECTION]: 'Sélection d\'une société',
        [MODES.CONTACT_SEARCHES]: 'Critères de recherche',
        [MODES.CONTACT_SELECTION]: 'Sélection d\'un contact',
        [MODES.CONTACT_CREATE]: 'Création d\'un contact',
        [MODES.USER_CREATE]: 'Création d\'un utilisateur',
        [MODES.CONTACT_UPDATE]: 'Modification d\'un contact',
        [MODES.NOTE_CREATE]: 'Commentaire',
        [MODES.OPTION_UPDATE_DATE]: 'Modifier la date de fin d\'une option',
        [MODES.NEW_CALENDAR_ACTION]: 'NOUVELLE ACTION',
        [MODES.NOTES_LIST]: 'Note(s) de suivi',
        [MODES.PROMOTEUR_UPDATE]: 'Informations promoteur',
        [MODES.INTERLOCUTEUR_FORM]: 'Interlocuteur'
      }
      return titles[this.mode]
    },
    faIcon () {
      let icons = {
        [MODES.USER_SELECTION]: 'fas fa-user-plus',
        [MODES.RELATION_SELECTION]: 'fas fa-user-plus',
        [MODES.CONTACT_SELECTION]: 'fas fa-user-plus',
        [MODES.CONTACT_SEARCHES]: 'fas fa-search',
        [MODES.OPTION_UPDATE_DATE]: 'fas fa-pencil',
        [MODES.NOTE_CREATE]: 'fas fa-comment-alt',
        [MODES.MANAGE_NOTIFICATION]: 'fas fa-bell',
        [MODES.NOTES_LIST]: 'fas fa-comment-alt'
      }
      return icons[this.mode]
    },
    currentComponent () {
      const components = {
        [MODES.LOT_SELECTION]: 'LotSelection',
        [MODES.LOT_SELECTION_AMENAGEMENT]: 'LotSelection',
        [MODES.MANAGE_NOTIFICATION]: 'ManageNotification',
        [MODES.USER_SELECTION]: 'EntitySelection',
        [MODES.RELATION_SELECTION]: 'EntitySelection',
        [MODES.CONTACT_SEARCHES]: 'ContactSearch',
        [MODES.CONTACT_CREATE]: 'ContactForm',
        [MODES.USER_CREATE]: 'UserQuickviewForm',
        [MODES.CONTACT_UPDATE]: 'ContactForm',
        [MODES.CONTACT_SELECTION]: 'EntitySelection',
        [MODES.OPTION_UPDATE_DATE]: 'OptionUpdateDateModal',
        [MODES.NOTE_CREATE]: 'NoteCreate',
        [MODES.NEW_CALENDAR_ACTION]: 'NewCalendarAction',
        [MODES.NOTES_LIST]: 'NotesList',
        [MODES.PROMOTEUR_UPDATE]: 'PromoteurForm',
        [MODES.INTERLOCUTEUR_FORM]: 'InterlocuteurForm'
      }
      return components[this.mode]
    }
  },
  watch: {
    quickview ({ mode = null, params = null, results = null, close = false }) {
      if (mode && !results && !close) {
        this.open({ mode, params })
      } else if (close) {
        this.close()
      }
    }
  },
  methods: {
    askSubmit () {
      if (this.forContactVue.includes(this.$route.name)) {
        this.$nextTick(function () {
          var container = document.querySelector('#gotop')
          if (container) {
            container.scrollTo(0, 0)
          }
        })
      }
      if (this.$refs && this.$refs.innerComponent) {
        this.$refs.innerComponent.submitQuickview()
      }
    },
    newNote () {
      if (this.$refs && this.$refs.innerComponent) {
        this.$refs.innerComponent.openWysiMeth()
      }
    },
    async submitQuickview (results) {
      if (this.params.source && (this.params.source.type === 'advComment' || this.params.source.type === 'optionComment')) {
        let payload = {
          comment: results.note.message
        }
        if (this.params.source.type === 'advComment') {
          try {
            await this.$store.dispatch('getcurrentAdv', this.params.rdvPk)
            await this.$store.dispatch('patchAdv', payload)
            this.$toasted.global.success('Commentaire mis a jour')
          } catch (e) {
            console.log(e)
            this.$toasted.global.danger('Erreur lors de la mise à jour')
          }
        } else {
          try {
            // payload = {
            //   pk: this.params.optionPk
            // }
            await this.$store.dispatch('getcurrentOption', this.params.optionPk)
            await this.$store.dispatch('patchOption', payload)
            this.$toasted.global.success('Commentaire mis a jour')
          } catch (e) {
            console.log(e)
            this.$toasted.global.danger('Erreur lors de la mise à jour')
          }
        }
        this.$store.commit('closeQuickview', { mode: null, params: null, results: null, close: true })
      } else if (this.params.alert && this.params.alert === true && this.mode === 'CONTACT_CREATE' && !results.contact.pk) {
        this.$store.commit('setQuickview', { mode: 'CONTACT_CHECK_CREATE', params: this.params, results: this.params })
      } else if (this.params.alert && this.params.alert === true && (this.mode === 'CONTACT_UPDATE' || results.contact.pk)) {
        this.$store.commit('setQuickview', { mode: 'CONTACT_CHECK_UPDATE', params: this.params, results: this.params })
      } else {
        this.$store.commit('setQuickview', { mode: this.mode, params: this.params, results: results })
      }
    },
    open ({ mode, params }) {
      this.mode = mode
      this.params = Object.assign({}, params)
      this.customValiderLabel()
      this.active = true
    },
    goBack () {
      this.$store.commit('setQuickview', {
        mode: this.params.previousMode,
        params: this.params.previousParams
      })
    },
    close () {
      this.$store.commit('setClaimCreateContact', false)
      this.$nextTick(() => {
        this.mode = null
        this.params = null
        this.active = false
        this.validerLabel = 'Valider'
      })
    },
    customValiderLabel () {
      if (this.mode === 'MANAGE_NOTIFICATION') {
        this.validerLabel = 'Enregistrer préférences'
      }
    }
  }
}
</script>
